import React from "react";
import pinned from "../assets/images/Pinned.svg";
import unpinned from "../assets/images/Unpin.svg";
import { commonservices } from "../services/CommonServices";

const WorkflowCostSummaryModel = ({
  activeRightSidePinnedPanel,
  FnForsetActiveRightSidePanel,
  FnForsetActiveRightSidePinnedPanel,
  nodes,
  WorkFlowMachineStatus,
  isViewMode,
}) => {
  const uniqueNodes = nodes?.filter(
    (item, index, self) =>
      index === self.findIndex((el) => el.typeid === item.typeid)
  );

  return (
    <div className="project-view-summary-sec-main project-view-cost-summary-sec-main">
      <div className="summary-title cursor-pointer">
        <h3
          onClick={() =>
            FnForsetActiveRightSidePanel(activeRightSidePinnedPanel)
          }
        >
          Cost Summary
        </h3>
        {!isViewMode && (
          <img
            className="workflow-pin-icon"
            src={activeRightSidePinnedPanel === "costSummary" ? pinned : unpinned}
            alt="analatics"
            onClick={() =>
              activeRightSidePinnedPanel === "costSummary"
                ? FnForsetActiveRightSidePinnedPanel("sm-panel")
                : FnForsetActiveRightSidePinnedPanel("costSummary")
            }
          />
        )}
      </div>
      <div className="cost-summary-body">
        <h3>Execution Cost Summary</h3>
        <div className="cost-summary-box">
          <div className="small-scroll">
            <div className="cost-summary-head">
              <h4>Machines </h4>
              <h4>Last Run</h4>
              <h4>Prev. Run</h4>
            </div>

            {WorkFlowMachineStatus?.map((item, index) => {
              return (
                <div className="cost-summary-items">
                  <h5
                    title={commonservices.makeMachineDisplayName(
                      item?.machinename,
                      0,
                      item?.assemblyname,
                      item?.workflowmachinename
                    )}
                  >
                    {commonservices.makeMachineDisplayName(
                      item?.machinename,
                      0,
                      item?.assemblyname,
                      item?.workflowmachinename
                    )}
                  </h5>
                  <p>
                    {item?.consumptioncost
                      ? "$ " + item?.consumptioncost?.toFixed(5)
                      : "-"}
                  </p>
                  <p>
                    {item?.prevconsumptioncost
                      ? "$ " + item?.prevconsumptioncost?.toFixed(5)
                      : "-"}
                  </p>
                </div>
              );
            })}
            <div className="cost-summary-total">
              <h5>Total</h5>
              <p>
                ${" "}
                {WorkFlowMachineStatus.reduce(
                  (sum, item) => sum + (item.consumptioncost || 0),
                  0
                ).toFixed(5)}
              </p>
              <p>
                ${" "}
                {WorkFlowMachineStatus.reduce(
                  (sum, item) => sum + (item.prevconsumptioncost || 0),
                  0
                ).toFixed(5)}
              </p>
            </div>
          </div>
        </div>
        <h3>Machines Use in this workflow </h3>
        {uniqueNodes?.map((item, index) => {
          return (
            <>
              <div
                className="cost-summary-single-main cost-summary-items"
                key={index}
              >
                <p title={item?.typeName}>{item?.typeName}</p>
                <span>{item?.price ? "$" + item?.price : "Free"}</span>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default WorkflowCostSummaryModel;
